import { colorNames } from '@/constants/colors'

export const subStageMap = {
  'pending-qualification': {
    color: colorNames.graySolid,
    label: 'Pending Qualification',
  },
  'pending-app-submit': {
    color: colorNames.tropicalBlue,
    label: 'Pending App Submit',
  },
  'pending-doc-upload': {
    color: colorNames.azureRadiance,
    label: 'Pending Doc Upload',
  },
  'pending-file-setup': {
    color: colorNames.toreaBay,
    label: 'Pending File Setup',
  },
  'pending-condl-approval-uw': {
    color: colorNames.studioPurple,
    label: "Pending Cond'l Approval",
  },
  'pending-ie-delivery': {
    color: colorNames.flirt,
    label: 'Pending IE Delivery',
  },
  'pending-intent-to-proceed': {
    color: colorNames.bahamaBlue,
    label: 'Pending Intent to Proceed',
  },
  'pending-order-outs': {
    color: colorNames.frenchLilac,
    label: 'Pending Order Outs',
  },
  'pending-3rd-party-receipts': {
    color: colorNames.lilacBush,
    label: 'Pending 3rd Party Receipts',
  },
  'pending-final-approval-uw': {
    color: colorNames.pinkSalmon,
    label: 'Pending Final Submission',
  },
  'pending-final-approval-uam': {
    color: colorNames.red,
    label: 'Pending Final Approval',
  },
  'pending-ics-delivery': {
    color: colorNames.midnightBlue,
    label: 'Pending ICS Delivery',
  },
  'pending-ics-signature': {
    color: colorNames.portage,
    label: 'Pending ICS Signature',
  },
  'pending-doc-draw': {
    color: colorNames.carrotOrange,
    label: 'Pending Doc Draw',
  },
  'pending-signature': {
    color: colorNames.blazeOrange,
    label: 'Pending Signature',
  },
  'pending-escrow-disbursement': {
    color: colorNames.pizazz,
    label: 'Pending Escrow Disbursement',
  },
  'pending-recording': {
    color: colorNames.greenHaze,
    label: 'Pending Recording',
  },
  'closed-won': {
    color: colorNames.harlequin,
    label: 'Closed Won',
  },
  'closed-lost': {
    color: colorNames.navyBlue,
    label: 'Closed Lost',
  },
}

export const allStates = Object.keys(subStageMap)
